import { currencyFormatter as formatCurrecny } from '@axo/shared/util/formatters';

export const currencyFormatter = (amount = 0) => formatCurrecny(amount, 'nok');
